import React from "react";
import { IntlShape } from "react-intl";
import { withFormik, FormikProps, FormikErrors, Form } from "formik";

import { TextFieldComponent, ClickableComponent } from "@app/core";
import { SelectComponent } from "@app/core/select";
import { platformType, getTranslatedPlatforms } from "@app/constants/platform";
import { getTranslatedBannerTypes } from "@app/constants/banner";

import styles from "./create-banner-modal-component.module.scss";
import { BANNERTYPEENUM } from "@app/api/generated";

export interface ICreateBannerFormValues {
  name: string;
  platform: platformType;
  type?: BANNERTYPEENUM;
}

interface IOtherProps {
  intl: IntlShape;
  isLoading: boolean;
  onCancel: () => void;
}

const InnerForm = (props: IOtherProps & FormikProps<ICreateBannerFormValues>) => {
  const { touched, errors } = props;

  const translatedPlatforms = getTranslatedPlatforms(props.intl);
  const translatedBannerTypes = getTranslatedBannerTypes(props.intl);

  return (
    <Form>
      <div className={styles.form}>
        <div className={styles.row}>
          <div className={styles.formField}>
            <SelectComponent
              id="platform"
              height={40}
              onChange={props.handleChange}
              options={translatedPlatforms}
              label={{
                label: props.intl.formatMessage({ id: "createBannerForm.input.platform.label" })
              }}
            />
          </div>
          <div className={styles.formField}>
            <SelectComponent
              id="type"
              height={40}
              onChange={props.handleChange}
              options={translatedBannerTypes}
              label={{
                label: props.intl.formatMessage({ id: "createBannerForm.input.bannerType.label" }),
                tooltip: props.intl.formatMessage({ id: "createBannerForm.input.bannerType.tooltip" })
              }}
            />
          </div>
        </div>
        <div className={styles.formField}>
          <TextFieldComponent
            placeholder=""
            value={props.values.name}
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            type="text"
            id="name"
            errorMessage={touched.name === true && errors.name}
            label={{
              label: props.intl.formatMessage({ id: "createBannerForm.input.name.label" }),
              tooltip: props.intl.formatMessage({ id: "createBannerForm.input.name.tooltip" })
            }}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        <span className={styles.firstButton}>
          <ClickableComponent
            title={props.intl.formatMessage({ id: "createBannerForm.button.cancel" })}
            onClick={() => {
              props.onCancel();
            }}
            height={48}
            variant="primary-inverted"
          />
        </span>
        <span>
          <ClickableComponent
            buttonType="submit"
            title={props.intl.formatMessage({ id: "createBannerForm.button.add" })}
            height={48}
            disabled={props.isLoading}
          />
        </span>
      </div>
    </Form>
  );
};

interface IFormProps {
  intl: IntlShape;
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: (values: ICreateBannerFormValues) => void;
}

export const CreateBannerFormComponent = withFormik<IFormProps, ICreateBannerFormValues>({
  mapPropsToValues: () => ({
    platform: 1,
    name: "",
    type: undefined
  }),

  validate: (values: ICreateBannerFormValues, props) => {
    const errors: FormikErrors<ICreateBannerFormValues> = {};
    if (!values.name) {
      errors.name = props.intl.formatMessage({ id: "createBannerForm.error.name.required" });
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    bag.props.onSubmit(values);
  }
})(InnerForm);
